import { navigateToUrl } from 'single-spa'
import { CarIcon, RocketIcon, TaskIcon } from '@autoplan/web-ui'
import type { FleetFilter } from '@autoplan/common'
import { useLocale } from '@autoplan/web-sanity'
import { useUser } from '@_shared/context/UserProvider'
import { WEB_MODULES } from '@_shared/types'
import { TaskCard } from './Cards/TaskCard'
import { useFleetSummary } from '../hooks/useFleetSummary'

const goToCarPark = (filter: FleetFilter) => navigateToUrl(`/carpark?filter=${filter}`)

export const TaskCardRow = () => {
  const { t } = useLocale()
  const { canAccess } = useUser()
  const hasCarParkAccess = canAccess(WEB_MODULES.CAR_PARK)
  const { summary, isLoading, isError } = useFleetSummary(hasCarParkAccess)

  if (!hasCarParkAccess) return null

  const state = { isLoading, isError }

  return (
    <div className="ap:overflow-x-auto ap:-ml-3xl ap:-mr-2xl ap:px-2xl ap:py-xl ap:-my-xl ap:snap-x ap:snap-mandatory ap:scroll-px-xl ap:[scrollbar-width:none] ap:[&::-webkit-scrollbar]:hidden">
      <div className="ap:flex ap:flex-row ap:items-stretch ap:gap-xl">
        <TaskCard
          icon={<RocketIcon />}
          title={t('home.fleet.overMileage')}
          subtitle={t('home.fleet.overMileageDescription', { count: summary?.overMileageCount ?? 0 })}
          priority="high"
          onClick={() => goToCarPark('overmileage')}
          {...state}
        />
        <TaskCard
          icon={<TaskIcon />}
          title={withCount(summary?.unresolvedCount, t('home.fleet.unresolved'))}
          subtitle={t('home.fleet.unresolvedDescription')}
          priority="high"
          onClick={() => goToCarPark('unresolved')}
          {...state}
        />
        <TaskCard
          icon={<CarIcon />}
          title={withCount(summary?.expiringCount, t('home.fleet.expiring'))}
          subtitle={
            <>
              {t('home.fleet.expiringDescription')} <strong>{t('home.fleet.expiringPeriod')}</strong>
            </>
          }
          priority="medium"
          onClick={() => goToCarPark('expiring')}
          {...state}
        />
        <div className="ap:min-w-xl ap:shrink-0" />
      </div>
    </div>
  )
}

function withCount(count: number | undefined, label: string) {
  return count === undefined ? label : `${count} ${label}`
}
